import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UserNameLabel from 'flow-doctor-lib/components/common/UserNameLabel';
import FlowBulkEnrollmentInfoIcon from 'flow-doctor-lib/components/common/FlowBulkEnrollmentInfoIcon';
import FlowNameLabel from 'flow-doctor-lib/components/common/FlowNameLabel';
import ChatflowNameLabel from 'flow-doctor-lib/components/common/ChatflowNameLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentEventTimelineItemLabel = ({
  enrollmentLog
}) => {
  // Note: Curious if this case is actually surfaced in the wild
  if (!enrollmentLog.enrollType) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.objectLifecycle.genericEnrollment"
    });
  }
  if (enrollmentLog.enrollType === 'MANUAL_ENROLL') {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "flow-doctor-lib.flows.objectLifecycle.events.ENROLLMENT.MANUAL_ENROLL_jsx",
      elements: {
        UserName: UserNameLabel
      },
      options: {
        userId: enrollmentLog.contextMap.USER_ID
      }
    });
  }
  if (enrollmentLog.enrollType === 'ACTION_EXECUTION_ENROLL') {
    if (enrollmentLog.contextMap.SOURCE_FLOW_ID) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.events.ENROLLMENT.ACTION_EXECUTION_ENROLL.withFlow_jsx",
        elements: {
          b: 'b',
          FlowNameLabel
        },
        options: {
          portalId: enrollmentLog.portalId,
          flowId: enrollmentLog.contextMap.SOURCE_FLOW_ID
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.objectLifecycle.events.ENROLLMENT.ACTION_EXECUTION_ENROLL.withoutFlow"
    });
  }
  if (enrollmentLog.enrollType === 'EXTERNAL_TRIGGER_ENROLL') {
    if (enrollmentLog.contextMap.CHATFLOW_ID) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.events.ENROLLMENT.EXTERNAL_TRIGGER_ENROLL.withChatflow_jsx",
        elements: {
          b: 'b',
          ChatflowNameLabel
        },
        options: {
          portalId: enrollmentLog.portalId,
          chatflowId: enrollmentLog.contextMap.CHATFLOW_ID
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.objectLifecycle.events.ENROLLMENT.EXTERNAL_TRIGGER_ENROLL.withoutChatflow"
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `flow-doctor-lib.flows.objectLifecycle.events.ENROLLMENT.${enrollmentLog.enrollType}`,
      useGap: true
    }), enrollmentLog.enrollType === 'BULK_ENROLL' && enrollmentLog.contextMap.BULK_ENROLL_ID && /*#__PURE__*/_jsx(FlowBulkEnrollmentInfoIcon, {
      portalId: enrollmentLog.portalId,
      bulkProcessingId:
      // TODO: Really bad types here..
      enrollmentLog.contextMap.BULK_ENROLL_ID
    })]
  });
};
export default EnrollmentEventTimelineItemLabel;